import type { PageHelpEntry, PageHelpGuide } from './types.js';

export const GENERAL_HELP_ENTRIES: readonly PageHelpEntry[] = [
  {
    paths: ['/', '/admin'],
    guide: {
      id: 'home',
      title: 'خانهٔ فضای کاری',
      purpose:
        'خانه مثل میز کار روزانهٔ شماست؛ خلاصهٔ کارها و اطلاعاتی را می‌بینید که به آن‌ها دسترسی دارید.',
      example:
        'مثال آموزشی: اول روز کارهای در انتظار را می‌بینید و برای رسیدگی وارد بخش مربوط می‌شوید.',
      steps: [
        'خلاصه‌ها و کارهای نمایش‌داده‌شده را مرور کنید.',
        'برای دیدن جزئیات، کارت یا بخش مربوط را باز کنید.',
        'برای رفتن به یک کار مشخص، از منوی بخش‌ها یا جست‌وجوی بالای صفحه استفاده کنید.',
      ],
      result: 'می‌دانید امروز از کدام کار شروع کنید و جزئیاتش را کجا پیدا کنید.',
      tips: [
        'ندیدن یک بخش می‌تواند به دسترسی شما یا فعال‌بودن آن در سازمان مربوط باشد؛ از مدیر سازمان بپرسید.',
      ],
    },
  },
  {
    paths: ['/admin/users'],
    guide: {
      id: 'users',
      title: 'کاربران و دسترسی‌ها',
      purpose:
        'اینجا همکاران را به فضای کاری دعوت می‌کنید و مشخص می‌کنید هر نفر چه بخش‌هایی را ببیند یا چه کارهایی انجام دهد.',
      example:
        'مثال آموزشی: فروشنده به اطلاعات فروش نیاز دارد؛ لازم نیست برای کار روزانه نقش مدیر سازمان داشته باشد.',
      steps: [
        'فهرست اعضا و نقش هر نفر را بررسی کنید.',
        'برای افزودن همکار، «دعوت همکار جدید» را باز کنید و مشخصات و سمت او را وارد کنید.',
        'متن دعوت و نتیجهٔ ارسال را بررسی کنید؛ برای تغییر دسترسی، نقش‌ها و مجوزهای همان فرد را باز کنید.',
      ],
      result: 'همکار با هویت خودش وارد می‌شود و در محدودهٔ دسترسی تعیین‌شده کار می‌کند.',
      tips: [
        'سمت سازمانی و مجوز نرم‌افزار یک چیز نیستند؛ دسترسی‌های واقعی را هم بررسی کنید.',
        'دعوت‌شدن با کامل‌شدن ورود و پذیرش دعوت فرق دارد.',
      ],
    },
  },
  {
    paths: ['/admin/subscription'],
    guide: {
      id: 'subscription',
      title: 'اشتراک سازمان',
      purpose: 'وضعیت اشتراک، ظرفیت کاربران و امکانات فعال سازمان را اینجا می‌بینید.',
      example:
        'مثال آموزشی: پیش از دعوت چند همکار جدید، ظرفیت کاربران و وضعیت اعتبار اشتراک را بررسی می‌کنید.',
      steps: [
        'وضعیت فعلی و زمان پایان اشتراک یا دورهٔ آزمایشی را بخوانید.',
        'ظرفیت کاربران و بخش‌های فعال را بررسی کنید.',
        'اگر اقدام پرداخت یا تمدید نمایش داده می‌شود، جزئیات و نتیجهٔ همان اقدام را دنبال کنید.',
      ],
      result: 'می‌دانید سازمان از چه امکاناتی و تا چه زمانی می‌تواند استفاده کند.',
      tips: [
        'اشتراک نرم‌افزار و اعتبار مصرف هوش مصنوعی جدا هستند؛ برای اعتبار دستیار، کیف پول توکن را ببینید.',
      ],
    },
  },
  {
    paths: ['/admin/security'],
    guide: {
      id: 'security',
      title: 'وضعیت امنیت حساب',
      purpose:
        'نشست یعنی یک ورود به حساب از یک دستگاه یا مرورگر. اینجا نشست‌ها و وضعیت احراز هویت دومرحله‌ای را می‌بینید.',
      example:
        'مثال آموزشی: ورود روی رایانهٔ محل کار را با نشست فعلی مقایسه می‌کنید تا دستگاه ناآشنا را تشخیص دهید.',
      steps: [
        'فهرست نشست‌ها و علامت «این دستگاه» را بررسی کنید.',
        'زمان‌ها و وضعیت هر نشست را بخوانید.',
        'اگر ورود ناآشنا دیدید، موضوع را با مدیر سازمان یا پشتیبانی پیگیری کنید.',
      ],
      result: 'از وضعیت ورودها و روش‌های احراز هویت حساب مطلع می‌شوید.',
      tips: [
        'این صفحه وضعیت را نشان می‌دهد؛ وجود یک نشست به معنی امکان بستن آن از همین صفحه نیست.',
        'رمز و کد ورود خود را برای دیگران نفرستید.',
      ],
    },
  },
  {
    paths: ['/admin/ui-kit'],
    guide: {
      id: 'ui-kit',
      title: 'نمونهٔ اجزای رابط کاربری',
      purpose:
        'این صفحه نمونهٔ ظاهر دکمه‌ها، جدول‌ها و پیام‌های نرم‌افزار است تا شکل حالت‌های مختلف را بشناسید.',
      example: 'مثال آموزشی: ظاهر پیام خطا و پیام موفقیت را کنار هم می‌بینید.',
      steps: ['بخش نمونهٔ موردنظر را پیدا کنید.', 'حالت‌ها و توضیح کنار هر نمونه را بخوانید.'],
      result: 'با ظاهر و معنی اجزای رابط کاربری آشنا می‌شوید.',
      tips: ['داده‌ها و حالت‌های نمونهٔ این صفحه را گزارش عملکرد شرکت در نظر نگیرید.'],
    },
  },
  {
    paths: ['/data'],
    guide: {
      id: 'import-export',
      title: 'ورود و خروج اطلاعات',
      purpose:
        'اینجا فایل اطلاعات را بررسی می‌کنید و بعد از کنترل نتیجه، آن را به ساختار وارد می‌کنید. برای ثبت اولیهٔ اشخاص، کد، نام و نوع طرف‌حساب کافی است؛ فقط انتخاب فایل به معنی ثبت اطلاعات نیست.',
      example:
        'مثال آموزشی: برای یک شرکت، کد P001، نام «شرکت نمونه» و نوع organization را در قالب اکسل وارد می‌کنید؛ اطلاعات تماس را خالی می‌گذارید و پس از ثبت، در ویرایش همان طرف‌حساب تکمیل می‌کنید.',
      steps: [
        'راهنمای داخل بخش ورود اطلاعات را باز کنید و قالب همان نوع داده را بگیرید.',
        'در فایل اشخاص، کد، نام و نوع طرف‌حساب را پر کنید؛ نوع person برای شخص حقیقی و organization برای سازمان است. ستون‌های اختیاری می‌توانند خالی باشند؛ ساختار و عنوان ستون‌های الزامی قالب را حفظ کنید.',
        'فایل را انتخاب کنید؛ در «ورود تک‌جدولی»، ستون‌های فایل را به فیلدهای مقصد نگاشت کنید و نتیجهٔ بررسی ردیف‌ها را بخوانید.',
        'در مسیر راهنمایی‌شده، خطاها و کارهای باقی‌مانده را رسیدگی کنید؛ برای ردیف‌های هم‌کد، «بررسی گروه» را باز و منبع‌ها را مقایسه کنید و پیشنهادهای هوشمند منتظر تصمیم را جداگانه بخوانید.',
        'در همان مسیر راهنمایی‌شده، برای هر اتصال اطلاعات اصلی را خودتان انتخاب و تصمیم را صریحاً تأیید کنید؛ برای جدا ماندن چند مورد، همان موارد را انتخاب و تصمیم گروهی را پس از خواندن تأیید ثبت کنید.',
        'در مسیر راهنمایی‌شده، پس از رسیدگی به موارد باز، بخش‌های بررسی‌شده را تأیید کنید و پیش‌نمایش را بخوانید؛ عددهای فنی تحلیل در جزئیات بازشدنی‌اند.',
        'فقط پس از بررسی، ثبت نهایی را انجام دهید و مقصد داده‌ها و ردیف‌های ردشده را کنترل کنید؛ برای افزودن اطلاعات اختیاری، همان رکورد موجود را ویرایش کنید.',
      ],
      result:
        'نتیجهٔ بررسی و ثبت را می‌بینید و رکوردهای واردشده را در بخش مربوط پیدا می‌کنید؛ اطلاعات اختیاری اشخاص را می‌توانید بعداً در ویرایش همان رکورد تکمیل کنید.',
      tips: [
        'خروجی سپیدار یا هلو لزوماً هم‌قالب فایل ساختار نیست؛ عنوان ستون‌ها و ارتباط مشتری، کالا و انبار را کنترل کنید.',
        'شناسه ملی، کد اقتصادی، آدرس و اطلاعات تماس برای ثبت اولیهٔ اشخاص اختیاری‌اند؛ اگر مقداری وارد کنید باید معتبر و در محدودهٔ مجوز شما باشد. در مسیر راهنمایی‌شده، «حقیقی» و «حقوقی» هم به‌عنوان نوع پذیرفته می‌شوند؛ در ورود تک‌جدولی از person و organization استفاده کنید.',
        'ورود دوبارهٔ طرف‌حساب با همان کد، اطلاعات پروندهٔ موجود را تکمیل نمی‌کند؛ از ایجاد دوبارهٔ رکورد صرف‌نظر می‌شود. برای تکمیل اطلاعات، از ویرایش همان رکورد استفاده کنید و پیام نتیجه یا خطای احتمالی را بخوانید.',
        'در ورود تک‌جدولی اشخاص، ردیف‌های سالم می‌توانند ثبت شوند و ردیف‌های خطادار رد می‌شوند. این قاعده را به مسیر راهنمایی‌شده تعمیم ندهید؛ ردیف خطادار نمی‌تواند به گروه وصل شود و خطاهای لازم باید پیش از پیش‌نمایش و ثبت برطرف شوند.',
        'گروه‌بندی ردیف‌های هم‌کد فقط برای ساده‌تر شدن نمایش است؛ گروه یا پیشنهاد هوشمند بدون انتخاب و تأیید شما به رکورد دیگری وصل نمی‌شود.',
        'تصمیم گروهی «جدا نگه دار» فقط برای موارد انتخاب‌شده است؛ پیش از تأیید، انتخاب‌ها را کنترل کنید.',
        'اگر نتیجهٔ ثبت روشن نیست، پیش از ارسال دوبارهٔ فایل نتیجهٔ قبلی را بررسی کنید.',
      ],
    },
  },
  {
    paths: ['/ai'],
    guide: {
      id: 'ai-chat',
      title: 'گفتگو با دستیار هوشمند',
      purpose:
        'سؤال کاری خود را به زبان معمولی می‌پرسید و می‌توانید جدول یا نمودار بخواهید؛ تحلیل اطلاعات شرکت در محدودهٔ دسترسی شما انجام می‌شود.',
      example:
        'مثال آموزشی: می‌پرسید «ارزش موجودی انبارها را با نمودار مقایسه کن» و واحد مبلغ و منبع داده‌های پاسخ را هم بررسی می‌کنید.',
      steps: [
        'موضوع و معیار مقایسه یا نمودار را روشن بنویسید؛ اگر زمان مهم است، بازهٔ موردنظر را هم مشخص کنید.',
        'اگر دستیار سؤال تکمیلی یا درخواست تأیید نشان داد، جزئیات آن را بخوانید.',
        'بازهٔ زمانی و جست‌وجوی عمیق را پیش از ارسال بررسی کنید؛ بستن تنظیمات به‌تنهایی درخواست تازه‌ای نیست.',
        'متن، جدول و نمودار موجود را کنار هم بخوانید؛ عنوان، واحد، محدوده و منبع داده را کنترل کنید.',
        'اگر نموداری نمایش داده نشد، داده‌ها و توضیح محدودیت پاسخ را بررسی کنید و نبود نمودار را صفر بودن مقدار فرض نکنید.',
      ],
      result:
        'پاسخ متنی و بسته به دادهٔ موجود، جدول یا نمودار مرتبط می‌بینید؛ نمودار به دادهٔ عددی مجاز و قابل‌نمایش نیاز دارد و عددهای آن از متن پاسخ حدس زده نمی‌شوند.',
      tips: [
        'پاسخ دستیار را پیش از تصمیم یا اقدام مالی با رکوردهای اصلی تطبیق دهید.',
        'نبود نمودار به معنی صفر بودن یا نبودن اطلاعات شرکت نیست؛ جدول، منبع و محدودیت‌های اعلام‌شدهٔ پاسخ را ملاک بررسی قرار دهید.',
        'درخواست اجرای یک کار با انجام‌شدن آن یکسان نیست؛ نتیجه و وضعیت اجرا را ببینید.',
        'قطع ارتباط یا تازه‌کردن صفحه، پایان اجرا یا صفرشدن مصرف را ثابت نمی‌کند؛ اگر نتیجه نامشخص است، همان درخواست را از مسیر بازیابی بررسی کنید و آن را بی‌دلیل دوباره نفرستید.',
        'سابقهٔ این مرورگر به حساب و شرکت فعلی محدود است؛ با ورود حساب دیگری، سابقهٔ حساب قبلی به آن منتقل نمی‌شود. پیش از تأیید حساب، ارسال پیام در دسترس نیست.',
      ],
    },
  },
  {
    paths: ['/ai/documents'],
    guide: {
      id: 'ai-documents',
      title: 'دانش و اسناد سازمانی',
      purpose:
        'معرفی شرکت، قواعد کاری و اسناد سازمان را اینجا آماده می‌کنید تا دستیار زمینهٔ کار شما را بهتر بفهمد.',
      example:
        'مثال آموزشی: قاعدهٔ پیگیری مشتریان یا توضیح خدمات شرکت را به دانش سازمان اضافه می‌کنید.',
      steps: [
        'اطلاعات شناخت شرکت و خط‌مشی‌ها را بررسی و تکمیل کنید.',
        'برای سند جدید، متن یا فایل را در بخش مربوط وارد کنید.',
        'پس از پردازش، وضعیت سند را بررسی کنید؛ آماده و فعال‌بودن منبع مهم است.',
      ],
      result:
        'منابع آماده و فعال می‌توانند در کنار داده‌های ثبت‌شدهٔ ERP به پاسخ‌های دستیار کمک کنند.',
      tips: [
        'صرف بارگذاری فایل به معنی آماده‌شدن آن برای پاسخ‌گویی نیست.',
        'توضیح یک مبلغ در سند متنی، رکورد مالی ERP را تغییر نمی‌دهد.',
      ],
    },
  },
  {
    paths: ['/ai/wallet'],
    guide: {
      id: 'ai-wallet',
      title: 'کیف پول هوش مصنوعی',
      purpose: 'اعتبار قابل‌استفاده، سابقهٔ مصرف و وضعیت خریدهای اعتبار دستیار را اینجا می‌بینید.',
      example:
        'مثال آموزشی: پیش از تحلیل چند تماس، اعتبار و مصرف‌های قبلی سازمان را بررسی می‌کنید.',
      steps: [
        'تعداد توکن باقی‌مانده را بخوانید؛ هر توکن ورودی یا خروجی واقعی، یک توکن از سهمیه کم می‌کند.',
        'برای خرید، پنجرهٔ خرید را باز کنید و یکی از سه بستهٔ پایه، حرفه‌ای یا سازمانی را انتخاب کنید. قیمت به ریال و تعداد توکن هر بسته ثابت است.',
        'پس از بازگشت از درگاه، وضعیت سفارش و موجودی را کنترل کنید.',
        'در سابقهٔ مصرف، جزئیات اجرای موردنظر را ببینید.',
      ],
      result:
        'سهمیهٔ توکن فقط پس از تأیید پرداخت اضافه می‌شود و خرید و مصرف شما در سابقه دیده می‌شود.',
      tips: [
        'بازشدن درگاه به معنی موفقیت خرید نیست؛ وضعیت نهایی سفارش را ببینید.',
        'خرید با مبلغ دلخواه فعلاً وجود ندارد، چون برای آن قیمت تأییدشده‌ای تعریف نشده است.',
        'خرید دوباره سهمیهٔ قبلی را حذف نمی‌کند؛ توکن‌های خریداری‌شده با هم جمع می‌شوند.',
        'در جدول سوابق خرید، ستون «سهمیه توکن» تعداد توکنِ ثبت‌شده برای همان سفارش است، نه مبلغ پرداختی ضرب در عدد ثابت.',
        'اگر پرداخت نیازمند بررسی است، پیش از خرید دوباره نتیجهٔ همان سفارش را پیگیری کنید.',
      ],
    },
  },
  {
    paths: ['/ai/settings'],
    guide: {
      id: 'ai-settings',
      title: 'تنظیمات دستیار',
      purpose:
        'مدیر مجاز سازمان می‌تواند وضعیت فعال‌بودن دستیار، محدوده‌ها و تنظیمات مصرف نمایش‌داده‌شده را اینجا بررسی کند.',
      example:
        'مثال آموزشی: پیش از شروع استفادهٔ تیم، فعال‌بودن دستیار و تنظیمات بودجهٔ دوره را کنترل می‌کنید.',
      steps: [
        'وضعیت فعال‌سازی و قابلیت‌های اعلام‌شده را بخوانید.',
        'تنظیمات مربوط به مصرف و نگهداری سوابق را بررسی کنید.',
        'برای هر تغییر، نتیجهٔ ذخیره و پیام همان بخش را کنترل کنید.',
      ],
      result: 'تنظیمات ذخیره‌شده و محدودیت‌های قابل‌استفادهٔ دستیار مشخص می‌شوند.',
      tips: [
        'همهٔ کاربران امکان تغییر تنظیمات سازمان را ندارند.',
        'فعال‌بودن یک یار به معنی آماده‌بودن تمام انواع عملیات نیست؛ قابلیت ثبت‌شدهٔ هر بخش را بخوانید.',
      ],
    },
  },
  {
    paths: ['/finance/assistant'],
    guide: {
      id: 'finance-assistant',
      title: 'یار مالی',
      purpose: 'اینجا درخواست‌های پیشنهادی یار مالی و وضعیت امکان استفاده از آن‌ها را می‌بینید.',
      example:
        'مثال آموزشی: یک درخواست مرتبط با بررسی وضعیت مالی را انتخاب می‌کنید و ورودی لازم آن را می‌خوانید.',
      steps: [
        'درخواست‌های موجود و توضیح هرکدام را بررسی کنید.',
        'وضعیت دسترسی و اعتبار موردنیاز را بخوانید.',
        'اگر اجرا در دسترس است، ورودی را کنترل و نتیجهٔ اجرا را بررسی کنید.',
      ],
      result: 'وضعیت درخواست و پاسخ یا علت در دسترس نبودن آن مشخص می‌شود.',
      tips: [
        'وجود عنوان یک درخواست به معنی ثبت خودکار سند مالی نیست؛ فقط نتیجهٔ واقعی اجرا را ملاک قرار دهید.',
      ],
    },
  },
  {
    paths: ['/account'],
    guide: {
      id: 'account',
      title: 'حساب کاربری من',
      purpose: 'مشخصات شخصی و تنظیمات ظاهر حساب خود را اینجا بررسی و ویرایش می‌کنید.',
      example: 'مثال آموزشی: نام نمایشی یا تصویر حساب و حالت روشن یا تاریک را تنظیم می‌کنید.',
      steps: [
        'اطلاعات حساب را بررسی کنید.',
        'فیلد یا تنظیم قابل‌ویرایش موردنظر را تغییر دهید.',
        'ذخیره را انجام دهید و پیام نتیجه را بخوانید.',
      ],
      result: 'تنظیمات شخصی ذخیره‌شده در حساب شما اعمال می‌شوند.',
      tips: ['تغییر مشخصات شخصی، نقش و مجوزهای سازمانی شما را تغییر نمی‌دهد.'],
    },
  },
  {
    paths: ['/mobile/notifications'],
    guide: {
      id: 'notifications',
      title: 'اعلان‌ها',
      purpose: 'خبرها و یادآوری‌هایی را می‌بینید که نرم‌افزار برای حساب شما ثبت کرده است.',
      example: 'مثال آموزشی: اعلان یک کار را باز می‌کنید و برای رسیدگی به رکورد مرتبط می‌روید.',
      steps: [
        'فهرست و وضعیت خوانده‌شدن اعلان‌ها را ببینید.',
        'اعلان موردنظر و لینک مرتبط آن را در صورت وجود باز کنید.',
        'برای بازگشت، از دکمهٔ بستن صفحه استفاده کنید.',
      ],
      result: 'از رویداد مربوط باخبر می‌شوید و محل پیگیری آن را پیدا می‌کنید.',
      tips: ['خواندن اعلان با انجام‌دادن کار مرتبط فرق دارد.'],
    },
  },
  {
    paths: ['/mobile/add'],
    guide: {
      id: 'quick-add',
      title: 'افزودن سریع',
      purpose: 'میان‌بر کارهای قابل‌دسترسی شماست؛ نوع کار را انتخاب می‌کنید تا فرم مربوط باز شود.',
      example:
        'مثال آموزشی: به‌جای پیدا کردن فرم از میان منوها، میان‌بر کار موردنظر را باز می‌کنید.',
      steps: [
        'گزینه‌های در دسترس را مرور کنید.',
        'نوع کار را انتخاب کنید.',
        'فرم مقصد را تکمیل کنید و نتیجهٔ ثبت را همان‌جا ببینید.',
      ],
      result: 'سریع‌تر به فرم اصلی انجام کار می‌رسید.',
      tips: ['زدن میان‌بر به‌تنهایی رکورد جدیدی ثبت نمی‌کند.'],
    },
  },
  {
    paths: ['/mobile/tasks'],
    guide: {
      id: 'my-tasks',
      title: 'کارهای من',
      purpose:
        'کارهای نمایش‌داده‌شده برای شما را یکجا می‌بینید تا بدانید چه چیزی نیاز به رسیدگی دارد.',
      example: 'مثال آموزشی: پیش از شروع روز، کار نزدیک به موعد را پیدا می‌کنید.',
      steps: [
        'عنوان، موعد و وضعیت کارها را بررسی کنید.',
        'کار موردنظر را برای مشاهدهٔ جزئیات و پیگیری باز کنید.',
      ],
      result: 'کار بعدی و مسیر پیگیری آن مشخص می‌شود.',
      tips: ['برای تغییر وضعیت، نتیجهٔ ثبت در صفحهٔ خودِ کار را بررسی کنید.'],
    },
  },
  {
    paths: ['/mobile/menu'],
    guide: {
      id: 'mobile-menu',
      title: 'منوی بخش‌ها',
      purpose: 'از این فهرست وارد بخش‌های در دسترس نرم‌افزار می‌شوید.',
      example: 'مثال آموزشی: برای دیدن موجودی کالا، بخش انبار را از منو پیدا می‌کنید.',
      steps: [
        'گروه مربوط به کارتان را پیدا کنید.',
        'بخش موردنظر را باز کنید.',
        'برای یادگیری صفحهٔ مقصد، دوباره «راهنمای این صفحه» را بزنید.',
      ],
      result: 'به صفحهٔ کاری موردنظر می‌رسید.',
      tips: ['اگر بخشی در دسترس نیست، فعال‌بودن آن و مجوز خود را با مدیر سازمان بررسی کنید.'],
    },
  },
];

export const GENERAL_FALLBACK_GUIDE: PageHelpGuide = {
  id: 'general',
  title: 'راهنمای کار با ساختار',
  purpose:
    'راهنمای اختصاصی این مسیر هنوز آماده نیست. برای پیدا کردن کار خود، از منوی بخش‌ها و جست‌وجو استفاده کنید.',
  example:
    'مثال آموزشی: برای دیدن اطلاعات یک مشتری، وارد فهرست مشتریان می‌شوید و مشتری را جست‌وجو می‌کنید.',
  steps: [
    'از منو وارد بخش مرتبط با کارتان شوید.',
    'در صفحهٔ مقصد، راهنمای همان صفحه را باز کنید.',
    'اگر صفحه یا اقدامی در دسترس نیست، با مدیر سازمان پیگیری کنید.',
  ],
  result: 'مسیر درست کار و راهنمای مرتبط را پیدا می‌کنید.',
  tips: ['باز و بسته کردن این راهنما اطلاعات شرکت را تغییر نمی‌دهد.'],
};
